<template>
  <v-container fluid style="height: 100%">
    <v-container
      fluid
      v-if="!hasLoadingError && organizationProfile"
      class="py-5 px-5 py-sm-15 px-sm-10 fill-height align-start"
    >
      <v-row>
        <v-col>
          <v-row>
            <v-col class="text-start">
              <span class="textLight--text font-weight-medium text-h5">
                {{ $t("organization.organizationProfile.organizationProfile") }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" lg="9">
              <v-row>
                <v-col cols="12">
                  <OrganizationProfileCard
                    :organizationData="organizationProfile"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="text-start">
              <span class="textLight--text font-weight-medium text-h5">
                {{ $t("user.basicInfo") }}
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" lg="9">
              <OrganizationBasicInfo
                :organizationData="organizationProfile"
                :loading="loading"
              />
            </v-col>
          </v-row>

          <v-row class="mb-3">
            <v-col cols="12">
              <v-tabs
                v-model="selectedTab"
                color="primary"
                background-color="transparent"
                active-class="primary--text"
              >
                <v-tab
                  v-for="(tab, index) in tabs"
                  :key="`org-profile-tab-${index}`"
                  class="px-0 me-4"
                  :style="{ maxWidth: '500px' }"
                >
                  <span class="text-h5 font-weight-medium text-none">
                    {{ tab.text }}
                  </span>
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-tabs-items v-model="selectedTab" class="transparent">
                <v-tab-item>
                  <EmployeeAndCoursesList
                    :organizationId="organizationProfile._id"
                  />
                </v-tab-item>

                <v-tab-item>
                  <OrganizationCourseValidity
                    :organization="organizationProfile"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-else-if="hasLoadingError" fluid class="fill-height">
      <Error />
    </v-container>
  </v-container>
</template>

<script>
import Error from "../../core-module/components/Error.vue";
import EmployeeAndCoursesList from "../components/organization-profile/EmployeesAndCoursesList.vue";
import OrganizationBasicInfo from "../components/organization-profile/OrganizationBasicInfo.vue";
import OrganizationProfileCard from "../components/organization-profile/OrganizationProfileCard.vue";
import OrganizationCourseValidity from "@/app/organization-module/components/organization-profile/OrganizationCourseValidity";

export default {
  components: {
    OrganizationCourseValidity,
    Error,
    EmployeeAndCoursesList,
    OrganizationBasicInfo,
    OrganizationProfileCard,
  },
  data() {
    return {
      hasLoadingError: false,
      organizationProfile: null,
      loading: true,
      selectedTab: 0,
    };
  },
  computed: {
    tabs() {
      return [
        {
          text: this.$t(
            "organization.organizationProfile.employeeAndAssignedCourses"
          ),
        },
        { text: this.$t("organization.organizationProfile.courseValidities") },
      ];
    },
  },
  watch: {
    "$route.params.organizationId": {
      handler() {
        if (!this.$route.params.organizationId) this.hasLoadingError = true;
        else {
          this.$apollo.addSmartQuery("getOrganizations", {
            query: require("@/app/organization-module/api/query/getOrganizations.gql"),
            variables: { limit: 0, skip: 0, filterInput: null },
            result({ data, loading }) {
              if (data?.getOrganizations?.organizations?.length) {
                this.organizationProfile =
                  data.getOrganizations.organizations.find(
                    obj => obj._id == this.$route.params.organizationId
                  );
              } else {
                this.hasLoadingError = true;
              }

              this.loading = loading;
            },
          });
        }
      },
      immediate: true,
    },
  },
};
</script>
